<script>
	export let index;
	export let runningIndex;
	export let type = "small";

	$: active = runningIndex >= index;

	$: className = `tracker-bit ${active ? 'active' : ''} type-${type}`;
</script>

<template>
	<div class={className} />
</template>

<style lang="stylus">
.tracker-bit
	width 100%
	background rgba(white, 0.2)
	flex 1
	margin-bottom 0.25rem
	border-radius 999px
	position relative

	&.type-small
		flex 1
	&.type-large
		flex 3

	&.type-cross
		flex 3

		&:after
			content ''
			display block
			position absolute
			top 25%
			width 300%
			height 0.5ch
			background inherit
			border-radius 999px
			transform translateX(0.25ch)
			left -150%

	&.type-medallion
		flex 2
		width 300%
		left 50%
		transform translateX(-50%)

	&.active
		background white

	&:last-child
		margin-bottom 0
</style>
